import React from 'react';
export default React.createContext(null);


//////////////////
// WEBPACK FOOTER
// ./~/react-transition-group/esm/TransitionGroupContext.js
// module id = 299
// module chunks = 0